module.exports = __webpack_public_path__ + "img/stick_patrimoine_village.445ed30b.svg";